import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import { generateDirStyles } from "../../../SharedComponents/GenerateDirStyles/GenerateDirStyles";

const baseStyles = {
	container: {
		position: "absolute",
		width: 210,
		minHeight: 35,
		maxHeight: 250,
		overflowY: "scroll",
		zIndex: 999,
		color: "#fff",
		borderRadius: 4,
		background: "#28292B no-repeat padding-box",
		opacity: 1,
		pointerEvents: "auto"
	},
	menuItemWrapper: {
		display: "flex",
		alignItems: "center",
		paddingLeft: 14.9,
		height: 35,
		cursor: "pointer",
		transition: "background-color 0.2s ease"
	},
	icon: {
		width: 30,
		height: 12,
		transform: "scale(0.75)",
		transformOrigin: "top left"
	},
	menuItem: {
		textAlign: "left",
		fontFamily: "Roboto",
		fontSize: "10px",
		fontWeight: "normal",
		lineHeight: "24px",
		letterSpacing: "0px",
		color: "#FFFFFF",
		opacity: 1,
		paddingLeft: 12.08
	}
};
const NestedMenu = ({ nestedMenuContent }) => {
	const dir = useSelector((state) => getDir(state));
	const styles = generateDirStyles(baseStyles, dir);

	return (
		<div style={styles.container}>
			{nestedMenuContent.length > 0 &&
				nestedMenuContent.map((menuItem, index) => {
					return (
						<div
							style={styles.menuItemWrapper}
							onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#484A4E")}
							onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#28292B")}
							key={index}
							onClick={() => {
								menuItem.action();
							}}
						>
							<div style={styles.icon}>{menuItem.icon}</div>
							<div style={styles.menuItem}>{menuItem.item}</div>
						</div>
					);
				})}
		</div>
	);
};

NestedMenu.propTypes = {
	nestedMenuContent: PropTypes.array.isRequired,
	mainMenuHeight: PropTypes.number.isRequired
};

export default NestedMenu;
